// extracted by mini-css-extract-plugin
export default {"sm":"576px"};